import React from 'react'
// import { FormattedMessage, useIntl } from 'react-intl'
// import { NormalRightarrowLine, SystemArrowSmallRightLine } from '@m-ui/icons'
import { Tabs } from 'm-ui'
import { LocaleInfoKey } from 'locales/I18N';
import { LanguageType } from 'types/enum';
import less from './index.module.less'
import { LanguageOptions } from 'layouts/Header'


const { TabPane } = Tabs

interface IProps {
  locale: LanguageType;
  setLocale: (value: LocaleInfoKey) => void,
}

const LanguageOverlay: React.FC<IProps> = (props) => {
  // const [activeTabKey, setActiveTabKey] = useState<string>('#/overlay1')
  const onTabChange = (key: string) => {
    // setActiveTabKey(key)
    props.setLocale(key as LanguageType)
  }

  return (
    <div className={less.container}>
      <Tabs
        tabPosition="left"
        defaultActiveKey={props.locale}
        // activeKey={activeTabKey}
        onTabClick={(key) => {
            onTabChange(key)
        }}
      >
        {
          LanguageOptions.map((item) => {
            return (
              <TabPane
                  tab={
                      <span className={less.titleSpan}>
                          <span>{item.value}</span>
                          {/* <NormalRightarrowLine className={less.titleSpanIcon} /> */}
                      </span>
                  }
                  key={item.key}
              />
            )
          })
        }
        {/* <TabPane
            tab={
                <span className={less.titleSpan}>
                    <span>中文</span>
                    <NormalRightarrowLine className={less.titleSpanIcon} />
                </span>
            }
            key='#/overlay2'
        /> */}
      </Tabs>
    </div>
  )
}

export default LanguageOverlay